var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVG-Layer",
    fill: "#B40202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45768268,19.8140855 C8.99207301,19.3951135 8.94505941,18.1165112 9.45768268,17.554532 L11.8255094,15.4049974 L18.0990094,9.91140806 C18.9082094,9.36790806 20.0049094,9.58410806 20.5476094,10.3932081 C20.9984094,11.0656081 20.9349094,11.9576081 20.3932094,12.5585081 L12.1071362,19.8140855 C11.3535274,20.4260547 9.86546272,20.229605 9.45768268,19.8140855 Z",
    id: "Path",
    transform: "translate(14.968855, 14.907259) rotate(-4.000000) translate(-14.968855, -14.907259) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5199731,19.999568 C9.05436343,19.5805959 9.00734983,18.3019937 9.5199731,17.7400145 L11.8877998,15.5904799 L18.1612998,10.0968905 C18.9704998,9.55339053 20.0671998,9.76959053 20.6098998,10.5786905 C21.0606998,11.2510905 20.9971998,12.1430905 20.4554998,12.7439905 L12.1694267,19.999568 C11.4158178,20.6115372 9.92775314,20.4150875 9.5199731,19.999568 Z",
    id: "Path",
    transform: "translate(15.031145, 15.092741) rotate(-90.000000) translate(-15.031145, -15.092741) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C6.71561,30 0,23.2844 0,15 C0,6.71561 6.71561,0 15,0 C23.2844,0 30,6.71561 30,15 C30,23.2844 23.2844,30 15,30 Z M15,3.52939 C8.66473,3.52939 3.52939,8.66473 3.52939,15 C3.52939,21.3353 8.66473,26.4706 15,26.4706 C21.3353,26.4706 26.4706,21.3353 26.4706,15 C26.4706,8.66473 21.3353,3.52939 15,3.52939 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossmark);
export default __webpack_public_path__ + "static/media/crossmark.cde65d22d30f2b03d3e1ff4c60cec401.svg";
export { ForwardRef as ReactComponent };